<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div v-if="loadingStarted">
        <Loading></Loading>
      </div>
      <div v-if="loadingCompleted">
          <div class="raw-data-container">
            <div class="page-header-container">
              <span class="font-secondary page-header">Study Summary</span>
            </div>
            <div v-if="thereAreParticipants" class="row">
              <div class="column-left">
                <div v-for="(participant, index) in allParticipants">
                  <div v-bind:class="selectedParticipantCSS(participant)" class="participant-container" v-on:click="selectParticipant(participant)">
                    <span>{{participantName(participant, index)}}</span>
                  </div>
                </div>
                <div v-if="currentParticipantLoaded" class="info-layout-container">
                  <div>Gender: {{gender}}</div>
                  <div>Age: {{age}}</div>
                  <div>{{segmentQuestion}}: {{segmentQuestionAnswer}}</div>
                  <div>Cookie Tracker: {{cookieTracker}}</div>
                  <div>Linker: {{linker}}</div>
                </div>
              </div>
              <div class="column-right">
                <div class="answers-container">
                    <div class="answer-container header">
                      <div class="row">
                        <div class="permutations">
                          <span>Perm</span>
                        </div>
                        <div class="rating">
                          <span>Rating</span>
                        </div>
                        <div class="response-time">
                          <span>Response time (seconds)</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="currentParticipantLoading">
                      <Loading></Loading>
                    </div>
                    <div v-for="answer in currentParticipantAnswers">
                      <div v-if="currentParticipantLoaded" class="answer-container">
                        <div class="row">
                                <div class="permutations">
                                  <div v-for="perm in answer.permutation.answers">
                                    <span>{{perm.answer}}</span>
                                  </div>
                                </div>
                                <div class="rating">
                                  <span>{{answer.rating.rating}}</span>
                                </div>
                                <div class="response-time">
                                  <span>{{formatResponseTime(answer.rating.responseTime)}}</span>
                                </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div v-else>
              Looks like there are not any participants
            </div>
          </div>
      </div>
      <div v-if="loadingFailed">
        Error
      </div>
    </div>
  </div>
</template>

<script>
    import http from "../../services/axios"
    import {
      GET_BACKEND_URL,
      GET_HTTP_CONFIG, LOADING_COMPLETED_FAILURE,
      LOADING_COMPLETED_SUCCESS,
      LOADING_STARTED
    } from "../../services/constants"

    export default {
        name: "RawData",

      created() {
        let id = this.$route.params.id
        http.get(this.$store.getters[GET_BACKEND_URL](`studies/${id}/participants?completed=true`), this.$store.getters[GET_HTTP_CONFIG])
          .then(response =>  {
            console.log(response)
            this.participants = response.data
            return http.get(this.$store.getters[GET_BACKEND_URL](`v2/studies/${id}`), this.$store.getters[GET_HTTP_CONFIG])
          })
          .then(response => {
            this.study = response.data
            this.loadingStatus = LOADING_COMPLETED_SUCCESS
            if(this.thereAreParticipants){
              this.selectParticipant(this.participants[0])
            }
          })
          .catch(err => {
            this.loadingStatus = LOADING_COMPLETED_FAILURE
          })
      },

      data(){
        return{
          loadingStatus: LOADING_STARTED,
          currentParticipantAnswersStatus: LOADING_STARTED,
          participants: [],
          currentParticipantAnswers:[],
          currentParticipant: {},
          study: {},
        }
      },

      computed: {
        loadingStarted(){
          return this.loadingStatus === LOADING_STARTED
        },
        loadingCompleted(){
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        loadingFailed(){
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
        allParticipants(){
          return this.participants
        },
        currentParticipantLoading(){
          return this.currentParticipantAnswersStatus === LOADING_STARTED
        },
        currentParticipantLoaded(){
          return this.currentParticipantAnswersStatus === LOADING_COMPLETED_SUCCESS
        },
        gender(){
          return this.currentParticipant.gender === 1 ? 'Male' : 'Female'
        },
        age(){
          return this.currentParticipant.ageDescription
        },
        segmentQuestion(){
          return this.study.surveyParamaters.segmentQuestions[0].question
        },
        segmentQuestionAnswer(){
          return this.currentParticipant.prelimAnswer
        },
        cookieTracker(){
          return this.currentParticipant.cookieIdentifier
        },
        linker(){
          return this.currentParticipant.userProvidedIdentifier
        },
        thereAreParticipants(){
          return this.participants.length > 0
        },
      },

      methods: {
        selectParticipant(participant){
          console.log(participant)
          this.currentParticipantAnswersStatus = LOADING_STARTED
          this.getParticipantAnswers(participant)
        },
        getParticipantAnswers(participant){
          let studyID = this.$route.params.id
          http.get(this.$store.getters[GET_BACKEND_URL](`studies/${studyID}/participants/${participant.id}/ratings`), this.$store.getters[GET_HTTP_CONFIG])
            .then(response => {
              console.log(response)
              this.currentParticipantAnswers = response.data
              this.currentParticipant = participant
              this.currentParticipantAnswersStatus = LOADING_COMPLETED_SUCCESS
            })
            .catch(err => {

            })
        },
        formatResponseTime(time){
          return time/1000
        },
        participantName(participant, index){
          return participant.email === 'N/A' ? `Participant ${index+1}` : participant.email
        },
        selectedParticipantCSS(participant){
          return {
            'selected-participant': participant.id === this.currentParticipant.id
          }
        },
      },

    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .raw-data-container{
    margin: 2em;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

  .column-left {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .participant-container{
    border: 1px solid $gray-2;
    padding: 5px 10px;
    cursor: pointer;
  }

  .column-right {
    display: flex;
    flex-direction: column;
    flex: 4;
  }
  .answers-container{
    padding: 0 2em;
  }
  .answer-container{
    border-bottom: 1px solid $gray-2;
    padding: 5px 10px;
  }
  .permutations{
    display: flex;
    flex-direction: column;
    flex: 3;
  }
  .rating{
    display: flex;
    flex-direction: column;
    flex: 3;
  }
  .response-time{
    display: flex;
    flex-direction: column;
    flex: 3;
  }

  .info-layout-container{
    padding: 1em 0;
    font-size: 14px;
  }

  .header{
    background-color: $gray-1;
    padding-top: 1em;
    padding-bottom: 1em;
  }

  .selected-participant{
    background-color: $gray-2;
  }

  .page-header-container{
    padding-top: 2em;
    padding-bottom: 4em;
  }

  .page-header{
    color: $red-2;
    font-size: 20pt;
    font-weight: bolder;
  }

</style>
